import umSelectuser from './um-selectuser';
umSelectuser.install = Vue => Vue.component(umSelectuser.name, umSelectuser);//注册组件
　// 标签的方式引入，留到后面再另开新篇讨论
  //const install = function(Vue, opts = {}) { 
　//　　Vue.component(sumFunction.name, sumFunction);
　//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

export default umSelectuser;


// WEBPACK FOOTER //
// ./src/packages/selectuser/index.js